import { render, staticRenderFns } from "./statisticsBlance.vue?vue&type=template&id=da5f2d66&scoped=true&"
import script from "./statisticsBlance.vue?vue&type=script&lang=js&"
export * from "./statisticsBlance.vue?vue&type=script&lang=js&"
import style0 from "./statisticsBlance.vue?vue&type=style&index=0&id=da5f2d66&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5f2d66",
  null
  
)

export default component.exports